import { Col, Row } from 'antd';
import { LABEL_TYPE } from 'components/common/Input/types';
import { get } from 'lodash';
import React from 'react';
import { SortableElement } from 'react-sortable-hoc';

import { InputComponentStyled } from '../styled';
import { InputProps } from '../types';
import DragHandle from './DragHandle';
import { MainAndSideInputsContainer } from './styled';
import { INewInitalFieldsProps } from './types';

const UpdateProfileInput: React.FC<{
  sideFieldComponents?: any[];
  fieldInput: InputProps;
  totalSideFieldSize: number;
  defaultValue: any;
  extra?: any;
  draggable?: boolean;
  label?: string;
  dragDisable?: boolean;
  sectionData?: INewInitalFieldsProps;
}> = ({
  sideFieldComponents,
  fieldInput,
  totalSideFieldSize,
  defaultValue,
  extra,
  draggable,
  dragDisable,
  sectionData,
}) => {
  const inputName = fieldInput.name;
  const labelType = get(fieldInput, 'labelType', LABEL_TYPE.above);
  return (
    <MainAndSideInputsContainer
      className='addable-input-element-container'
      style={{ flexWrap: 'nowrap' }}
      key={inputName}>
      {draggable && <Col style={{ display: 'flex', minWidth: 25 }}>{!dragDisable && <DragHandle />}</Col>}
      <Col flex='auto'>
        <Row justify='space-between'>
          {sideFieldComponents}
          <Col span={24} lg={sideFieldComponents ? 24 - totalSideFieldSize || 24 : 24}>
            <InputComponentStyled
              // key={index}
              // label={width < parseInt(breakpoints.lg, 10) ? label : ''}
              {...fieldInput}
              label={!sectionData?.labelProps ? fieldInput.label : undefined}
              labelType={labelType}
              extra={extra}
              defaultValue={defaultValue}
            />
          </Col>
        </Row>
      </Col>
    </MainAndSideInputsContainer>
  );
};

export default SortableElement(UpdateProfileInput);
